export const SCAN_IN = 1;
export const SCAN_OUT = 2;
export const SCAN_REENTRY = 3;

/**
 * Scan.
 *
 * @param {Object}  params - Object parameter
 * @param {string}  params.uuid - Unique identifier
 * @param {integer} params.attendee - Attendee id
 * @param {string}  params.barcode - Barcode
 * @param {integer} params.checkpoint - Checkpoint id
 * @param {string}  params.device - Device
 * @param {string}  params.origin - Origin
 * @param {integer} params.status - Status
 * @param {string}  params.identificationUuid - identification uuid
 * @param {string}  params.pairedBarcode - Paired barcode
 * @param {string}  params.pairedCashlessAdditivePairing - paired cashless additive pairing
 * @param {string}  params.pairedCashlessData - paired Cashless Data
 * @param {integer} params.partnerId - Partner id
 * @param {string}  params.partnerName - Partner name
 * @param {string}  params.partnerUsername - Partner username
 * @param {string}  params.removed - DateTime of removal
 * @param {string}  params.validated - DateTime of validation
 * @param {string}  params.modified - DateTime of Last Modification
 * @constructor
 */
export default class Scan {
	constructor({
		uuid,
		attendee,
		barcode,
		checkpoint,
		device,
		origin,
		status,
		validated,
		modified,
		removed,
		identification_uuid: identificationUuid,
		paired_barcode: pairedBarcode,
		paired_cashless_additive_pairing: pairedCashlessAdditivePairing,
		paired_cashless_data: pairedCashlessData,
		partner_id: partnerId,
		partner_name: partnerName,
		partner_username: partnerUsername,
		is_offline_resolved: isOfflineResolved,
		online_response_ms: onlineResponseMs
	} = {}) {
		this._uuid = uuid;
		this._attendee = attendee;
		this._barcode = barcode;
		this._checkpoint = checkpoint;
		this._device = device;
		this._identification_uuid = identificationUuid;
		this._origin = origin;
		this._paired_barcode = pairedBarcode;
		this._paired_cashless_additive_pairing = pairedCashlessAdditivePairing;
		this._paired_cashless_data = pairedCashlessData;
		this._partner_id = partnerId;
		this._partner_name = partnerName;
		this._partner_username = partnerUsername;
		this._status = status;
		this._validated = validated;
		this._modified = modified;
		this._removed = removed;
		this._is_offline_resolved = isOfflineResolved;
		this._online_response_ms = onlineResponseMs;
	}

	uuid() {
		return this._uuid;
	}

	attendeeId() {
		return this._attendee;
	}

	barcode() {
		return this._barcode;
	}

	checkpointId() {
		return this._checkpoint;
	}

	device() {
		return this._device;
	}

	identificationUuid() {
		return this._identification_uuid;
	}

	origin() {
		return this._origin;
	}

	pairedBarcode() {
		return this._paired_barcode;
	}

	pairedCashlessAdditivePairing() {
		return this._paired_cashless_additive_pairing;
	}

	pairedCashlessData() {
		return this._paired_cashless_data;
	}

	partnerId() {
		return this._partner_id;
	}

	partnerName() {
		return this._partner_name;
	}

	partnerUsername() {
		return this._partner_username;
	}

	status() {
		return this._status;
	}

	validated() {
		return this._validated;
	}

	modified() {
		return this._modified;
	}

	removed() {
		return this._removed;
	}

	setRemoved(date = null) {
		this._removed = date;
	}

	isOfflineResolved() {
		return this._is_offline_resolved;
	}

	onlineResponseMs() {
		return this._online_response_ms;
	}
}
